import { Button } from "primereact/button";
import React, { useState } from "react";
import TotalRecords from "../../../../components/core/total-records";

const MobileLockerCards = ({
  lockerCleanupData,
  selectedRows,
  setSelectedRows,
  searchCriteria,
  setOpenPulloutCode,
  accessPermission,
}) => {
  const [expandedId, setExpandedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} week(s) ago`;
    return `${Math.floor(diffDays / 30)} months ago`;
  };

  const filteredData = lockerCleanupData.filter(
    (item) =>
      item.waybillNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.lockerLocation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.partnerAgentMobile?.includes(searchTerm) ||
      item.recipientMobile?.includes(searchTerm)
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  // const filteredData = filteredData.slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage
  // );

  const toggleSelect = (item) => {
    const isSelected = selectedRows.some(
      (row) => row.waybillNumber === item.waybillNumber
    );
    if (isSelected) {
      setSelectedRows(
        selectedRows.filter((row) => row.waybillNumber !== item.waybillNumber)
      );
    } else {
      setSelectedRows([...selectedRows, item]);
    }
  };

  const toggleSelectAll = () => {
    const allSelected = filteredData.every((item) =>
      selectedRows.some((row) => row.waybillNumber === item.waybillNumber)
    );

    if (allSelected) {
      const waybillsToRemove = filteredData.map((item) => item.waybillNumber);
      setSelectedRows(
        selectedRows.filter(
          (row) => !waybillsToRemove.includes(row.waybillNumber)
        )
      );
    } else {
      const newSelections = filteredData.filter(
        (item) =>
          !selectedRows.some((row) => row.waybillNumber === item.waybillNumber)
      );
      setSelectedRows([...selectedRows, ...newSelections]);
    }
  };

  const isSelected = (item) => {
    return selectedRows.some((row) => row.waybillNumber === item.waybillNumber);
  };

  const allPageSelected =
    filteredData.length > 0 && filteredData.every((item) => isSelected(item));
  const showCheckboxes =
    searchCriteria.lockerId && searchCriteria.lockerId !== "-1";

  return (
    <div className="md:hidden">
      {/* Select All Bar */}
      {showCheckboxes && (
        <div className="bg-white border-b px-4 py-3 flex gap-2 items-center">
          <button
            onClick={toggleSelectAll}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors border ${
              allPageSelected
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {allPageSelected ? "Deselect All" : "Select All"}
          </button>
          <span className="text-sm text-gray-600">on this page</span>
        </div>
      )}

      {/* total records */}
      <TotalRecords count={filteredData.length} />

      {/* Package Cards */}
      <div className="p-1 space-y-3 pb-2">
        {filteredData.map((item) => (
          <div
            key={item.waybillNumber}
            className={`bg-white rounded-xl shadow-sm border overflow-hidden transition-all ${
              isSelected(item)
                ? "border-blue-500 ring-2 ring-blue-200"
                : "border-gray-200"
            }`}
          >
            {/* Card Header */}
            <div className="p-4">
              <div className="flex items-start gap-3">
                {/* Checkbox */}
                {showCheckboxes && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSelect(item);
                    }}
                    className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${
                      isSelected(item)
                        ? "bg-blue-600 border-blue-600"
                        : "border-gray-300 bg-white"
                    }`}
                  >
                    {isSelected(item) && (
                      <svg
                        className="w-3 h-3 text-white"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path d="M5 13l4 4L19 7"></path>
                      </svg>
                    )}
                  </button>
                )}

                {/* Content */}
                <div
                  className="flex-1 cursor-pointer"
                  onClick={() =>
                    setExpandedId(
                      expandedId === item.waybillNumber
                        ? null
                        : item.waybillNumber
                    )
                  }
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1 text-gray-900">
                        <i size={16} className=" pi pi-box" />
                        <span className="text-sm font-semibold ">
                          {item.waybillNumber}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="pi pi-map-marker " size={14} />
                        <span>{item.lockerLocation}</span>
                      </div>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                      <span className="bg-blue-500  text-white text-xs font-medium px-3 py-1 rounded-full">
                        {item.packageStateNo}
                      </span>
                      {expandedId === item.waybillNumber ? (
                        <i
                          size={20}
                          className="text-gray-400 pi pi-chevron-up"
                        />
                      ) : (
                        <i
                          size={20}
                          className="text-gray-400 pi pi-chevron-down"
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
                    <span className="text-xs text-gray-500">
                      {/* {getRelativeTime(item.packageDate)} */}
                      Package Date:
                    </span>
                    <span className="text-xs text-gray-400">
                      {formatDateTime(item.packageDate)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Expanded Details */}
            {expandedId === item.waybillNumber && (
              <div className="border-t border-gray-100 bg-gray-50 p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">Courier Mobile</span>
                  <div className="flex items-center gap-2">
                    <span className=" text-sm font-medium">
                      {item.partnerAgentMobile}
                    </span>
                    <a
                      href={`tel:${item.partnerAgentMobile}`}
                      className="text-yellow-600 hover:text-yellow-700"
                    >
                      {/* <Phone size={18} /> */}
                    </a>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-600">
                    Recipient Mobile
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium">
                      {item.recipientMobile}
                    </span>
                    <a
                      href={`tel:${item.recipientMobile}`}
                      className="text-yellow-600 hover:text-yellow-700"
                    >
                      {/* <Phone size={18} /> */}
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Pagination */}
      {/* <div className="bg-white border-t px-4 py-3 flex items-center justify-between fixed bottom-0 left-0 right-0 shadow-lg z-10">
        <div className="text-xs text-gray-600">
          Page {currentPage} of {totalPages}
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm bg-white"
          >
            ««
          </button>
          <button
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm bg-white"
          >
            ‹
          </button>
          <button
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm bg-white"
          >
            ›
          </button>
          <button
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm bg-white"
          >
            »»
          </button>
        </div>
      </div> */}

      {/* Send Pullout Button */}
      {showCheckboxes && selectedRows.length > 0 && (
        <div className="fixed bottom-16 left-0 right-0 p-4 bg-gradient-to-t from-white via-white to-transparent pointer-events-none z-10">
          <Button
            size="small"
            onClick={() => setOpenPulloutCode(true)}
            disabled={
              accessPermission.lockerCleanUp === 1 ||
              accessPermission.lockerCleanUp === "1"
            }
            className="w-full bg-primary-primaryYellow hover:bg-primary-primaryYellowDark disabled:bg-gray-300 disabled:cursor-not-allowed text-gray-900 font-medium px-6 py-3 rounded-lg flex items-center justify-center gap-2 shadow-lg pointer-events-auto"
          >
            {/* <Send size={18} /> */}
            SEND PULLOUT CODE TO MAINTENANCE
          </Button>
        </div>
      )}

      {filteredData.length === 0 && (
        <div className="text-center py-12">
          {/* <Package size={48} className="mx-auto text-gray-300 mb-3" /> */}
          <p className="text-gray-500">No packages found</p>
        </div>
      )}
    </div>
  );
};

export default MobileLockerCards;
